var React = require('react');

function OpenDropdown (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Vector","d":"M15.9897 1.74937C15.9555 2.04355 15.8374 2.32227 15.649 2.5534L9.24951 10.41C9.09962 10.5941 8.90949 10.7427 8.6932 10.8448C8.47691 10.947 8.23999 11 8 11C7.76001 11 7.52309 10.947 7.3068 10.8448C7.0905 10.7427 6.90038 10.5941 6.75049 10.41L0.350974 2.5534C0.162557 2.32227 0.0444641 2.04355 0.0103045 1.74937C-0.0238552 1.45519 0.0273075 1.15752 0.157898 0.890655C0.288488 0.62379 0.493191 0.398593 0.748419 0.241015C1.00365 0.0834365 1.29901 -0.000111013 1.60048 0L14.3995 0C14.701 -0.000111013 14.9964 0.0834365 15.2516 0.241015C15.5068 0.398593 15.7115 0.62379 15.8421 0.890655C15.9727 1.15752 16.0239 1.45519 15.9897 1.74937Z","fill":"white","fillOpacity":"0.5"}));
}

OpenDropdown.defaultProps = {"width":"16","height":"11","viewBox":"0 0 16 11","fill":"none"};

module.exports = OpenDropdown;

OpenDropdown.default = OpenDropdown;
